import React from 'react';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PageHero from '../../components/PageHero';
import { Reveal, RevealGroup, RevealItem } from '../../components/Reveal';
import '../css/InternationalShipping.css';

const InternationalShipping = () => {
  const shippingRegions = [
    { region: 'North America', deliveryTime: '3-5 days', countries: 'USA, Canada, Mexico' },
    { region: 'Europe', deliveryTime: '5-7 days', countries: 'UK, Germany, France, Italy' },
    { region: 'Asia Pacific', deliveryTime: '4-6 days', countries: 'China, Japan, India, Australia' },
    { region: 'Middle East', deliveryTime: '6-8 days', countries: 'UAE, Saudi Arabia, Qatar' },
    { region: 'Latin America', deliveryTime: '7-10 days', countries: 'Brazil, Argentina, Chile' },
    { region: 'Africa', deliveryTime: '8-12 days', countries: 'South Africa, Kenya, Nigeria' },
  ];

  const features = [
    { icon: <PublicOutlinedIcon />, title: 'Worldwide Coverage', description: 'We deliver to major countries and regions across all continents.' },
    { icon: <Inventory2OutlinedIcon />, title: 'Secure Packaging', description: 'All products are securely packaged to ensure safe transit.' },
    { icon: <LocalShippingOutlinedIcon />, title: 'Fast Delivery', description: 'Express shipping options available for urgent orders.' },
    { icon: <LocationOnOutlinedIcon />, title: 'Order Tracking', description: 'Real-time tracking available for all international shipments.' },
  ];

  const processSteps = [
    { title: 'Order Confirmation', description: 'Your order is confirmed and prepared for shipment.' },
    { title: 'Quality Check', description: 'Products undergo thorough quality inspection.' },
    { title: 'Secure Packaging', description: 'Items are professionally packaged for safe transit.' },
    { title: 'Dispatch & Delivery', description: 'Order is shipped and delivered to your location.' },
  ];

  return (
    <div className="shipping-page">
      <PageHero
        eyebrow="Export & Shipping"
        title="Delivering quality tools worldwide."
        subtitle="We ship to over 50 countries with an efficient logistics network built for safe, timely delivery."
      />

      <section className="shipping-content">
        <div className="container">
          <Reveal className="intro-section">
            <h2 className="section-title">Global delivery services.</h2>
            <p>We ship our products to over 50 countries worldwide. Our efficient logistics network ensures safe and timely delivery of your orders, no matter where you are located.</p>
          </Reveal>

          <RevealGroup className="shipping-features">
            {features.map((f, i) => (
              <RevealItem key={i} className="feature-box glass-card">
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.description}</p>
              </RevealItem>
            ))}
          </RevealGroup>

          <div className="shipping-regions">
            <Reveal className="section-head centered">
              <span className="eyebrow">Coverage</span>
              <h2 className="section-title">Shipping regions & delivery times.</h2>
            </Reveal>
            <RevealGroup className="regions-grid">
              {shippingRegions.map((item, index) => (
                <RevealItem key={index} className="region-card glass-card">
                  <h3>{item.region}</h3>
                  <div className="delivery-info">
                    <span className="delivery-label">Delivery Time:</span>
                    <span className="delivery-value">{item.deliveryTime}</span>
                  </div>
                  <div className="countries-info">
                    <span className="countries-label">Includes:</span>
                    <span className="countries-value">{item.countries}</span>
                  </div>
                </RevealItem>
              ))}
            </RevealGroup>
          </div>

          <div className="shipping-process">
            <Reveal className="section-head centered">
              <span className="eyebrow">Our Process</span>
              <h2 className="section-title">From order to doorstep.</h2>
            </Reveal>
            <RevealGroup className="process-steps">
              {processSteps.map((step, index) => (
                <RevealItem key={index} className="process-step">
                  <div className="step-number">{index + 1}</div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </RevealItem>
              ))}
            </RevealGroup>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InternationalShipping;
